const config = Object.freeze({
    rowHeight: 65,
    tabHeight: 44,
    timelineNavHeight: 40,
    timelineNavColor: '#2c2c2c',
    headerColumnWidth: 240,
})

export default config
